const useConsoleLog = false;

export const customLog = useConsoleLog ? console.log.bind(window.console) : ()=>{};


// WEBPACK FOOTER //
// ./js/customLog.js